export default {
  auth: {
    auth: '/:key?',
    verification: '/verification',
  },

  console: {
    home: '/',
    scores: '/scores',
    rewards: '/rewards',
    userProfile: '/user-profile',
    sweepstakes: '/sweepstakes',
  },
} as const
